import { SVGProps, Ref, forwardRef } from 'react';

export const KeyOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.273 3.228c1.023 0 2.045.512 2.045 2.045 0 1.534-1.022 2.045-2.045 2.045s-2.045-.51-2.045-2.045S4.25 3.228 5.273 3.228m0 1.4c-.302 0-.457.079-.51.123a.25.25 0 0 0-.07.102 1.1 1.1 0 0 0-.065.42c0 .228.038.357.064.42.025.058.05.085.07.103.054.044.208.122.511.122s.457-.078.51-.122a.25.25 0 0 0 .07-.103c.027-.063.065-.192.065-.42s-.038-.357-.064-.42a.25.25 0 0 0-.07-.102c-.054-.044-.208-.123-.51-.123"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.954.5c2.727 0 5.455 1.364 5.455 5.454q-.002.799-.134 1.463l.816.816v1.13h1.13l.233.234v1.13h1.13l.916.916v2.834L11.643 15.5 7.41 11.268a7.4 7.4 0 0 1-1.457.141C3.227 11.41.5 10.045.5 5.954.5 1.864 3.227.5 5.954.5m0 1.4c-1.155 0-2.161.292-2.853.869-.648.54-1.2 1.477-1.2 3.185 0 1.709.552 2.647 1.2 3.187.692.577 1.698.868 2.853.868.407 0 .804-.038 1.179-.113l.737-.15 4.193 4.194 2.037-.54v-1.178l-.095-.095h-1.95v-1.363H10.69V8.813L9.76 7.88l.142-.732c.068-.348.108-.745.108-1.195 0-1.708-.553-2.646-1.2-3.185-.693-.578-1.7-.869-2.855-.869"
                fill="currentColor"
            />
        </g>
    </svg>
));
KeyOutlinedSize16Glyph.displayName = 'KeyOutlinedSize16Glyph';
